import {Form, Formik} from 'formik';
import Link from 'next/link';
import {useTranslation} from 'next-i18next';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import useRoutePaths from '@/src/hooks/useRoutePaths';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Button, Checkbox, Input, Text} from '../../../ui';
import css from '../styles/singIn.module.css';

interface SignInFormProps {
  handleSubmit: (...values: any) => void;
  isLoading: boolean;
}

interface formikRenderProps {
  errors: {
    general?: string;
  };
}

const SignInForm = ({handleSubmit, isLoading}: SignInFormProps) => {
  const {t} = useTranslation('common');
  const {FORGOT_PASSWORD_ROUTE} = useRoutePaths();

  return (
    <Formik
      initialValues={{
        email: '',
        password: '',
      }}
      validationSchema={getSignInSchema(t)}
      onSubmit={handleSubmit}
    >
      {({errors}: formikRenderProps) => {
        return (
          <Form className={css.form}>
            <div className={css.inputs}>
              {/*@ts-ignore*/}
              <Input
                name={'email'}
                placeholder={t('general.email')}
                type={Input.TYPES.EMAIL}
                width={Input.WIDTH.WIDTH_FULL}
              />
              {/*@ts-ignore*/}
              <Input
                name={'password'}
                placeholder={t('general.password')}
                type={Input.TYPES.PASSWORD}
                width={Input.WIDTH.WIDTH_FULL}
              />
            </div>
            <div className={css.addActions}>
              <Checkbox label={t('sing-in.remember-me')} name={'remember-me'} />
              <Link href={FORGOT_PASSWORD_ROUTE.getLink()}>
                <a>
                  <Text
                    fontSize={Text.FONT_SIZE.SIZE_14}
                    color={Text.COLOR.GREY}
                    lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_4}
                  >
                    <TextLocal id={'sing-in.forgot-password-q'} />
                  </Text>
                </a>
              </Link>
            </div>

            <div className={css.saveButtonWrapper}>
              {Boolean(errors.general) && (
                <div className={css.errorField}>{errors.general}</div>
              )}
              <Button
                color={Button.COLOR.PRIMARY}
                type="submit"
                isLoading={isLoading}
              >
                <TextLocal id={'sing-in.sing-in'} />
              </Button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
export default SignInForm;

SignInForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

SignInForm.defaultProps = {
  handleSubmit: () => {},
  isLoading: false,
};

const getSignInSchema = (t) =>
  Yup.object().shape({
    email: Yup.string()
      .test('sectionSymbol', t('emailStep.email_is_invalid'), (value) => {
        if (value === undefined) {
          return true;
        }

        return !value?.includes('§');
      })
      .email(t('emailStep.email_is_invalid'))
      .required(t('emailStep.email_is_required')),
    password: Yup.string().required(t('emailStep.password_is_required')),
  });
